<div class="container-fluid vh-100 p-0">
  <div class="row h-100 g-0">
    <!-- Left Side - App Information -->
    <div class="col-lg-7 col-xl-8 d-none d-lg-flex bg-primary bg-opacity-10 position-relative">
      <div class="d-flex flex-column justify-content-center align-items-center p-5 w-100">
        <!-- Logo and Title Section -->
        <div class="text-center mb-5">
          <h1 class="display-4 fw-bold text-primary mb-3">DigivCards</h1>
          <p class="lead text-muted">Transform Your Networking with Smart Digital Visiting Cards</p>
        </div>
        
        <!-- Image Carousel -->
        <div class="position-relative w-100 max-w-600">
          <div class="overflow-hidden rounded-3 shadow-lg bg-white">
            <div class="d-flex transition-all" 
                 [style.transform]="'translateX(' + (-currentSlide * 100) + '%)'">
              
              <!-- Step 1: Sign Up -->
              <div class="flex-shrink-0 w-100 p-5 text-center">
                <div class="p-4 rounded-3 mb-4 gradient-secondary">
                  <div class="mb-4">
                    <mat-icon class="display-1 text-warning">person_add</mat-icon>
                  </div>
                  <h3 class="h4 fw-bold mb-3 text-dark">Sign Up</h3>
                  <p class="text-muted">Create your account on our web platform</p>
                </div>
              </div>
              
              <!-- Step 2: Create -->
              <div class="flex-shrink-0 w-100 p-5 text-center">
                <div class="p-4 rounded-3 mb-4 gradient-secondary-alt">
                  <div class="mb-4">
                    <mat-icon class="display-1 text-primary">design_services</mat-icon>
                  </div>
                  <h3 class="h4 fw-bold mb-3 text-dark">Create</h3>
                  <p class="text-muted">Build your professional digital visiting card</p>
                </div>
              </div>
              
              <!-- Step 3: Share -->
              <div class="flex-shrink-0 w-100 p-5 text-center">
                <div class="p-4 rounded-3 mb-4 gradient-success">
                  <div class="mb-4">
                    <mat-icon class="display-1 text-success">share</mat-icon>
                  </div>
                  <h3 class="h4 fw-bold mb-3 text-dark">Share</h3>
                  <p class="text-muted">Connect instantly with prospects and clients</p>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Carousel Indicators -->
          <div class="d-flex justify-content-center mt-4">
            <button 
              *ngFor="let slide of slides; let i = index" 
              class="btn btn-sm rounded-circle me-2 avatar-xs"
              [class.btn-primary]="i === currentSlide"
              [class.btn-outline-primary]="i !== currentSlide"
              (click)="goToSlide(i)">
            </button>
          </div>
        </div>
        
        <!-- Tagline -->
        <div class="text-center mt-5">
          <p class="h5 text-primary fw-semibold">Start Seeing Results in 3 Minutes</p>
        </div>
      </div>
    </div>
    
    <!-- Right Side - Login Form -->
    <div class="col-lg-5 col-xl-4 d-flex flex-column">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center p-4">
        <div class="w-100 max-w-400">
          <mat-card class="border-0 shadow-lg">
            <!-- Logo -->
            <div class="text-center mb-4 pt-4">
              <img [src]="urls.logoUrl" alt="DigivCards.ai Logo" class="img-fluid max-h-60" />
            </div>

            <mat-card-header class="text-center pb-0">
              <mat-card-title class="h4 fw-bold">Welcome to DigivCards</mat-card-title>
              <mat-card-subtitle class="text-muted">Sign in to access your digital visiting card dashboard</mat-card-subtitle>
            </mat-card-header>
            
            <mat-card-content class="p-4">
              <!-- Error Message Display -->
              <div *ngIf="errorMessage" class="alert alert-danger border-0 mb-4" role="alert">
                <div class="d-flex align-items-start">
                  <mat-icon class="text-danger me-2 mt-1">error</mat-icon>
                  <div class="flex-grow-1">
                    <strong>Authentication Error</strong>
                    <p class="mb-0 mt-1">{{ errorMessage }}</p>
                  </div>
                </div>
              </div>

              <!-- Already authenticated message -->
              <div *ngIf="authService.currentUser?.uid" class="text-center auth-loading-container">
                <div class="d-flex flex-column align-items-center">
                  <div class="mb-3 auth-status-success">
                    <mat-icon style="font-size: 48px;">check_circle</mat-icon>
                  </div>
                  <h5 class="fw-semibold mb-2 auth-status-success">Already Signed In</h5>
                  <p class="text-muted mb-3">Welcome back! Redirecting to your dashboard...</p>
                  <mat-spinner diameter="30" class="mt-2"></mat-spinner>
                </div>
              </div>
              
              <!-- Loading placeholder for FirebaseUI -->
              <div *ngIf="isFirebaseUILoading && !authService.currentUser?.uid" class="text-center">
                <div class="d-flex flex-column align-items-center">
                  <mat-spinner diameter="40" class="mb-3"></mat-spinner>
                  <p class="text-muted">Loading authentication options...</p>
                </div>
              </div>
              
              <!-- FirebaseUI container -->
              <div #firebaseUIContainer 
                   [style.display]="authService.currentUser?.uid ? 'none' : 'block'"
                   [style.opacity]="isFirebaseUILoading ? '0' : '1'"
                   class="transition-opacity">
              </div>
              
              <!-- Account creation note -->
              <div *ngIf="!authService.currentUser?.uid && !errorMessage" class="alert alert-info border-0 mt-4">
                <div class="d-flex align-items-start">
                  <mat-icon class="text-info me-2 mt-1">lightbulb</mat-icon>
                  <div>
                    <strong>Don't have an account?</strong> No worries! Just login with your Google or email and we'll automatically set up your account. It's that simple!
                  </div>
                </div>
              </div>
              
              <div class="text-center mt-3">
                <p class="small text-muted">
                  Need help? Visit our 
                  <a [href]="urls.mainWebsite" target="_blank" class="text-decoration-none">
                    main website <mat-icon class="small">arrow_outward</mat-icon>
                  </a>
                </p>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      
      <!-- Footer -->
      <footer class="p-4 border-top bg-light">
        <!-- Footer Links -->
        <div class="text-center mb-3">
          <div class="d-flex flex-wrap justify-content-center align-items-center gap-2 small">
            <a [href]="urls.termsOfService" target="_blank" class="text-decoration-none text-muted">Terms of Service</a>
            <span class="text-muted">•</span>
            <a [href]="urls.privacyPolicy" target="_blank" class="text-decoration-none text-muted">Privacy Policy</a>
            <span class="text-muted">•</span>
            <a [href]="urls.contactUrl" target="_blank" class="text-decoration-none text-muted">Contact</a>
            <span class="text-muted">•</span>
            <a [href]="urls.support" target="_blank" class="text-decoration-none text-muted">Support</a>
          </div>
        </div>
        
        <!-- Copyright -->
        <div class="text-center mb-3">
          <p class="small text-muted mb-1">© 2025 Tamilarasi Technologies Private Limited</p>
          <p class="small text-muted mb-1">
            Visit <a [href]="urls.companyWebUrl" target="_blank" class="text-decoration-none">tamilarasi.com</a>
          </p>
          <p class="small text-muted">Made with ❤️ in India</p>
        </div>
        
        <!-- Security Badge -->
        <div class="d-flex justify-content-center align-items-center text-muted">
          <mat-icon class="me-2 text-success">security</mat-icon>
          <span class="small">Secure & Encrypted Login</span>
        </div>
      </footer>
    </div>
  </div>
</div>
